import React__default, { useRef, useState, useEffect } from 'react';
import { Button } from '../Button/Button.js';
import '../Button/ProgressButton/ProgressButton.js';
import { Typography } from '../Typography/Typography.js';
import { classNames } from '../../helpers/classnames.js';
import { IconButton } from '../IconButton/IconButton.js';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import { useComponentDidMount } from '../../helpers/use-component-did-mount.js';
import { snackbarTextFontLineHeight, snackbarTextMarginTop, snackbarElasticTextMarginBottom } from '@beeline/design-tokens/js/tokens/components/snackbar';

var Snackbar = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, message = _a.message, _c = _a.delay, delay = _c === void 0 ? 3000 : _c, onClose = _a.onClose, action = _a.action, _d = _a.closeButton, closeButton = _d === void 0 ? false : _d, _e = _a.horizontal, horizontal = _e === void 0 ? 'right' : _e, _f = _a.variant, variant = _f === void 0 ? 'elastic' : _f, className = _a.className;
    var isComponentMounted = useComponentDidMount();
    var snackbarRef = useRef(null);
    var _g = useState(false), multilineText = _g[0], setTextState = _g[1];
    // todo если текст многострочный, то стилистика меняется, наверное, можно убрать из зависимостей всё, кроме isComponentMounted
    // так как компонент должен быть статичный после отображения, но пока так
    useEffect(function () {
        var _a;
        var blockHeight = parseInt(snackbarTextFontLineHeight) + parseInt(snackbarTextMarginTop) + parseInt(snackbarElasticTextMarginBottom);
        setTextState(((_a = snackbarRef === null || snackbarRef === void 0 ? void 0 : snackbarRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) > blockHeight);
    }, [isComponentMounted, open, message, action, variant]);
    var actionButton = action && (React__default.createElement(Button, { variant: "plain", size: "small", className: "dsb_snackbar-body-action", onClick: action === null || action === void 0 ? void 0 : action.onClick }, (action === null || action === void 0 ? void 0 : action.label) || 'Закрыть'));
    var _h = useState(open), isOpen = _h[0], setOpenState = _h[1];
    var closeAction = function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setOpenState(false);
    };
    useEffect(function () {
        setOpenState(open);
    }, [open]);
    useEffect(function () {
        if (isOpen && !!delay) {
            var timer_1 = setTimeout(function () {
                closeAction();
            }, delay);
            return function () {
                clearTimeout(timer_1);
            };
        }
    }, [delay, onClose, isOpen]);
    if (!isOpen) {
        return null;
    }
    return (React__default.createElement("div", { className: 'dsb_snackbar-wrapper', "data-testid": "Snackbar" },
        React__default.createElement("div", { ref: snackbarRef, className: classNames('dsb_snackbar', open && 'dsb_snackbar__open', "dsb_snackbar__".concat(horizontal), 'inverseTheme', "dsb_snackbar__".concat(variant), multilineText && 'dsb_snackbar__multiline', className) },
            React__default.createElement("div", { className: classNames('dsb_snackbar-body') },
                React__default.createElement("div", { className: "dsb_snackbar-body_content-line" },
                    React__default.createElement(Typography, { variant: "body3", className: classNames('dsb_snackbar-body-message', action && 'dsb_snackbar-body-message__with-action', "dsb_snackbar-body-message__".concat(variant), closeButton && 'dsb_snackbar-body-message__with-close') }, message),
                    actionButton),
                closeButton &&
                    React__default.createElement("div", { className: "dsb_snackbar-body_close-block" },
                        React__default.createElement(IconButton, { iconName: Icons.Close, onClick: function () { closeAction(); } }))))));
};

export { Snackbar };
